import styled from '@emotion/styled'
import { CSSObject, Theme } from '@emotion/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudArrowUp } from '@fortawesome/pro-solid-svg-icons'

const BannerButton = styled.button(({theme}: {theme: Theme}): CSSObject => ({
	appearance: 'none',
	border: `1px solid ${theme.colors.orangeLight1}`,
	borderRadius: theme.borderRadius,
	background: theme.colors.orangeLight2,
	color: theme.colors.orangeDark,
	cursor: 'pointer',
	textAlign: 'left',
	width: '100%',
	display: 'grid',
	gridTemplateColumns: 'max-content 1fr',
	alignItems: 'center',
	gap: theme.spacing(2),
	padding: theme.spacing(2),
	fontSize: '15px',
	'&:hover': {
		background: theme.colors.orangeLight1,
	},
}))

const IconContainer = styled.div({
	fontSize: '18px',
	display: 'flex',
})

interface V2L3DashboardSyncBannerProps {
	count: number
	onClick?: () => void
}

// persistent dashboard banner shown while device-to-cloud items remain
// unsynced, so a clinician can't leave the app unaware their captured data
// is still only on the device. tapping triggers a sync.
export const V2L3DashboardSyncBanner = ({count, onClick}: V2L3DashboardSyncBannerProps) => {
	if(count <= 0) {
		return null
	}
	const noun = count === 1 ? 'item' : 'items'
	return (
		<BannerButton onClick={onClick}>
			<IconContainer>
				<FontAwesomeIcon icon={faCloudArrowUp} />
			</IconContainer>
			<div>
				You have {count} {noun} not yet synced. Tap here to sync now so your data is uploaded.
			</div>
		</BannerButton>
	)
}
